<script>
    import { createEventDispatcher, getContext, onMount } from "svelte";
    import client from "../../../client.js";
    import { apiRequest } from "../../../utils.js";

    let dispatch = createEventDispatcher();
    let options = getContext('options');
    let model_id = options.model_id;

    async function loadUrls() {
        const url = options.domain + 'api/urls';
        let data = {
            url: document.URL,
            model_id,
        };
        try {
            const response = await apiRequest(url, data);
            if (client.AR) {
                dispatch('showAr', response);
            }
            dispatch('share', response);
        } catch {
            return;
        }
    }

    onMount(() => {
        dispatch('loading');
        loadUrls();
    });
</script>